module.exports = __webpack_public_path__ + "static/media/Range of term of stay.03d30a17.svg";